import { PassedActivitiesStyle } from "./PassedActivitiesStyle";
import PassedActivitiesTab from "../PassedActivitiesTab/PassedActivitiesTab";

export const PassedActivities = () => {
  return (
    <PassedActivitiesStyle className="mt-3">
      <PassedActivitiesTab />
    </PassedActivitiesStyle>
  );
};
